import { useEffect, useState } from "react";
import NoOverflowWrapper from "../components/NoOverflowWrapper";
import Calendar from "../components/Calendar";
import { layout as layoutSchedule } from "../models/ModelSchedule";
import dates from "componentsv2/tools/dates";
import { useStore, insertRecord } from "storev2/formStore";
import "./styles.css";
import { useContext, initContext, setTimeData } from "../store/useContext";
import TabPages from "../components/TabPages";

function buildDateTime(date, time) {
  if (!date || !time) return null;
  let baseDate;
  if (typeof date === "string") {
    const [y, m, d] = date.split("-");
    baseDate = new Date(Number(y), Number(m) - 1, Number(d));
  } else {
    baseDate = new Date(date);
  }
  let hours = 0,
    minutes = 0,
    seconds = 0;
  if (typeof time === "string") {
    const parts = time.split(":");
    hours = Number(parts[0]) || 0;
    minutes = Number(parts[1]) || 0;
    seconds = Number(parts[2]) || 0;
  } else if (time instanceof Date) {
    hours = time.getHours();
    minutes = time.getMinutes();
    seconds = time.getSeconds();
  }
  baseDate.setHours(hours, minutes, seconds, 0);
  return baseDate;
}

const AppointmentCalendar = () => {
  const [showDialog, setShowDialog] = useState(false);
  const { newRecord } = useStore();
  const { updateContext } = useContext();

  async function closeDialog() {
    await setTimeData();
    setShowDialog(false);
  }

  const handleDay = async (e, day, start_date) => {
    if (day && day < dates.startOfToday()) return;

    const _layout = layoutSchedule();

    const storeId = await newRecord(_layout, null);

    const { updateForm, findRecord } = useStore.getState();
    const record = findRecord(storeId);

    if (day) {
      const appointment_date = dates.fmt(day, "yyyy-MM-dd");
      record.store.appointment_date = appointment_date;
      record.active.appointment_date = appointment_date;

      if (start_date) {
        const startDateTime = buildDateTime(appointment_date, start_date);
        record.store.start_date = startDateTime;
        record.active.start_date = startDateTime;
      }
    } else if (start_date) {
      const startDateTime = buildDateTime(new Date(), start_date);
      record.store.start_date = startDateTime;
      record.active.start_date = startDateTime;
    }

    updateForm(storeId, record.active, record.store);

    updateContext({
      currentEvent: { id: record.active.id, ...record.active, storeId },
    });
    setShowDialog(true);
  };

  const handleEvent = async (e, event) => {
    const { id } = event;
    e.stopPropagation();
    e.preventDefault();
    const _layout = layoutSchedule();
    const storeId = await insertRecord(id, _layout.model, _layout);
    updateContext({ currentEvent: { ...event, storeId } });
    setShowDialog(true);
  };

  useEffect(() => {
    async function refreshData() {
      await initContext();
      await setTimeData();
    }

    refreshData();
  }, []);

  return (
    <div className="w-full">
      {!showDialog && (
        <NoOverflowWrapper>
          <Calendar handleDay={handleDay} handleEvent={handleEvent} />
        </NoOverflowWrapper>
      )}
      {showDialog && (
        <TabPages onChangeView={closeDialog} onClose={closeDialog} />
      )}
    </div>
  );
};

export default AppointmentCalendar;
